MailingRouting.$inject = ["$urlRouterProvider", "$stateProvider"];

function MailingRouting($urlRouterProvider, $stateProvider) {

    if (projectType == "Admin")
        $urlRouterProvider.otherwise("/Mailing/Mail");
    else
        $urlRouterProvider.otherwise("/Mailing/Mail");


    $stateProvider

        .state(`${projectType == 'Admin' ? 'App.' : ''}Mailing`, {

            abstract: true,

            url: '/Mailing',

            template: '<ui-view id="Mailing"></ui-view>'

        })

        .state(`${projectType == 'Admin' ? 'App.' : ''}Mailing.Mail`, {

            url: '/Mail',

            controller: 'Mailing.MailController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./Mail/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./Mail/Mail.module');

                        $ocLazyLoad.load({

                            name: 'MailModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                title: "پیام رسان",
                icon: "fas fa-comments"
            }

        })
        .state(`${projectType == 'Admin' ? 'App.' : ''}Mailing.Mail.Inbox`, {

            url: '/Inbox',

            controller: 'Mailing.InboxController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./Inbox/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./Inbox/Inbox.module');

                        $ocLazyLoad.load({

                            name: 'InboxModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                title: "صندوق ورودی",
                icon: "fas fa-envelope"
            }

        })
        .state(`${projectType == 'Admin' ? 'App.' : ''}Mailing.Mail.Sent`, {

            url: '/Sent',

            controller: 'Mailing.SentController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./Sent/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./Sent/Sent.module');

                        $ocLazyLoad.load({

                            name: 'SentModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                title: "ارسال شده",
                icon: "fas fa-envelope"
            }

        })
        .state(`${projectType == 'Admin' ? 'App.' : ''}Mailing.Mail.Compose`, {

            url: '/Compose',

            controller: 'Mailing.ComposeController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./Compose/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./Compose/Compose.module');

                        $ocLazyLoad.load({

                            name: 'ComposeModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                title: "نوشتن پیام",
                icon: "fas fa-edit"
            }

        })
        .state(`${projectType == 'Admin' ? 'App.' : ''}Mailing.Mail.InboxMessage`, {

            url: '/Inbox/:messageId',

            controller: 'Mailing.InboxMessageController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./InboxMessage/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./InboxMessage/InboxMessage.module');

                        $ocLazyLoad.load({

                            name: 'InboxMessageModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                parent: `${projectType == 'Admin' ? 'App.' : ''}Mailing.Mail.Inbox`,
                title: "مشاهده پیام دریافتی",
                icon: "fas fa-envelope-open"
            }

        })
        .state(`${projectType == 'Admin' ? 'App.' : ''}Mailing.Mail.SentMessage`, {

            url: '/Sent/:messageId',

            controller: 'Mailing.SentMessageController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./SentMessage/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./SentMessage/SentMessage.module');

                        $ocLazyLoad.load({

                            name: 'SentMessageModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                parent: `${projectType == 'Admin' ? 'App.' : ''}Mailing.Mail.Sent`,
                title: "مشاهده پیام ارسالی",
                icon: "fas fa-envelope-open"
            }

        }) /*endOfResolve*/ ;

}



export default MailingRouting;